/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CollectionPackagingUnitCreateResponse } from '../models/collection-packaging-unit-create-response';
import { CollectionPackagingUnitHierarchyDto } from '../models/collection-packaging-unit-hierarchy-dto';
import { CollectionPackagingUnitUpdateResponse } from '../models/collection-packaging-unit-update-response';
import { createCollectionPackagingUnit } from '../fn/products/create-collection-packaging-unit';
import { CreateCollectionPackagingUnit$Params } from '../fn/products/create-collection-packaging-unit';
import { createProduct } from '../fn/products/create-product';
import { CreateProduct$Params } from '../fn/products/create-product';
import { deleteCollectionPackagingUnit } from '../fn/products/delete-collection-packaging-unit';
import { DeleteCollectionPackagingUnit$Params } from '../fn/products/delete-collection-packaging-unit';
import { getAllPackagingUnitIdEanPairs } from '../fn/products/get-all-packaging-unit-id-ean-pairs';
import { GetAllPackagingUnitIdEanPairs$Params } from '../fn/products/get-all-packaging-unit-id-ean-pairs';
import { getCollectionPackagingUnitHierarchies } from '../fn/products/get-collection-packaging-unit-hierarchies';
import { GetCollectionPackagingUnitHierarchies$Params } from '../fn/products/get-collection-packaging-unit-hierarchies';
import { getIdsByEanCodes } from '../fn/products/get-ids-by-ean-codes';
import { GetIdsByEanCodes$Params } from '../fn/products/get-ids-by-ean-codes';
import { getProductById } from '../fn/products/get-product-by-id';
import { GetProductById$Params } from '../fn/products/get-product-by-id';
import { getProductForAdminById } from '../fn/products/get-product-for-admin-by-id';
import { GetProductForAdminById$Params } from '../fn/products/get-product-for-admin-by-id';
import { getProducts } from '../fn/products/get-products';
import { GetProducts$Params } from '../fn/products/get-products';
import { getProductsForAdmin } from '../fn/products/get-products-for-admin';
import { GetProductsForAdmin$Params } from '../fn/products/get-products-for-admin';
import { getProductsForAdminByMerchantNameAsHal } from '../fn/products/get-products-for-admin-by-merchant-name-as-hal';
import { GetProductsForAdminByMerchantNameAsHal$Params } from '../fn/products/get-products-for-admin-by-merchant-name-as-hal';
import { getProductSheetById } from '../fn/products/get-product-sheet-by-id';
import { GetProductSheetById$Params } from '../fn/products/get-product-sheet-by-id';
import { PackagingUnitIdsByEanResponse } from '../models/packaging-unit-ids-by-ean-response';
import { PagedModelProductAdminResponse } from '../models/paged-model-product-admin-response';
import { PageProductPageResponse } from '../models/page-product-page-response';
import { ProductAdminResponse } from '../models/product-admin-response';
import { ProductCreateResponse } from '../models/product-create-response';
import { ProductDetailedResponse } from '../models/product-detailed-response';
import { ProductSheetResponse } from '../models/product-sheet-response';
import { updateCollectionPackagingUnit } from '../fn/products/update-collection-packaging-unit';
import { UpdateCollectionPackagingUnit$Params } from '../fn/products/update-collection-packaging-unit';
import { updateProduct } from '../fn/products/update-product';
import { UpdateProduct$Params } from '../fn/products/update-product';
import { updateProductStatus } from '../fn/products/update-product-status';
import { UpdateProductStatus$Params } from '../fn/products/update-product-status';


/**
 * Product (PackagingUnit) resource endpoints. A product in MKP is modelled as a PackagingUnit — the leaf-level sellable item. The 'packagingUnitId' path parameter identifies a product uniquely across the platform.
 */
@Injectable({ providedIn: 'root' })
export class ProductsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getProductById()` */
  static readonly GetProductByIdPath = '/products/{packagingUnitId}';

  /**
   * Get product by id.
   *
   * Returns detailed product data for the given packagingUnitId. This endpoint is publicly accessible (no authentication required). When called by an authenticated PRODUCT_ADMIN the 'editable' flag can be passed to include edit-mode metadata.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductById$Response(params: GetProductById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductDetailedResponse>> {
    const obs = getProductById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get product by id.
   *
   * Returns detailed product data for the given packagingUnitId. This endpoint is publicly accessible (no authentication required). When called by an authenticated PRODUCT_ADMIN the 'editable' flag can be passed to include edit-mode metadata.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductById(params: GetProductById$Params, context?: HttpContext): Observable<ProductDetailedResponse> {
    const resp = this.getProductById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductDetailedResponse>): ProductDetailedResponse => r.body)
    );
  }

  /** Path part for operation `updateProduct()` */
  static readonly UpdateProductPath = '/products/{packagingUnitId}';

  /**
   * Updates a product.
   *
   * Updates an existing product (PackagingUnit) identified by its packagingUnitId.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProduct$Response(params: UpdateProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates a product.
   *
   * Updates an existing product (PackagingUnit) identified by its packagingUnitId.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProduct(params: UpdateProduct$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateCollectionPackagingUnit()` */
  static readonly UpdateCollectionPackagingUnitPath = '/products/{packagingUnitId}/collections/{collectionPackagingUnitId}';

  /**
   * Updates a collection packaging unit.
   *
   * Updates an existing child packaging unit within a product collection. The collectionPackagingUnitId identifies the specific child node in the collection hierarchy.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCollectionPackagingUnit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCollectionPackagingUnit$Response(params: UpdateCollectionPackagingUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionPackagingUnitUpdateResponse>> {
    const obs = updateCollectionPackagingUnit(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates a collection packaging unit.
   *
   * Updates an existing child packaging unit within a product collection. The collectionPackagingUnitId identifies the specific child node in the collection hierarchy.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCollectionPackagingUnit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCollectionPackagingUnit(params: UpdateCollectionPackagingUnit$Params, context?: HttpContext): Observable<CollectionPackagingUnitUpdateResponse> {
    const resp = this.updateCollectionPackagingUnit$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CollectionPackagingUnitUpdateResponse>): CollectionPackagingUnitUpdateResponse => r.body)
    );
  }

  /** Path part for operation `deleteCollectionPackagingUnit()` */
  static readonly DeleteCollectionPackagingUnitPath = '/products/{packagingUnitId}/collections/{collectionPackagingUnitId}';

  /**
   * Deletes a collection packaging unit.
   *
   * Removes a child packaging unit from the collection hierarchy identified by collectionPackagingUnitId.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCollectionPackagingUnit()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCollectionPackagingUnit$Response(params: DeleteCollectionPackagingUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteCollectionPackagingUnit(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Deletes a collection packaging unit.
   *
   * Removes a child packaging unit from the collection hierarchy identified by collectionPackagingUnitId.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCollectionPackagingUnit$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCollectionPackagingUnit(params: DeleteCollectionPackagingUnit$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteCollectionPackagingUnit$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `updateProductStatus()` */
  static readonly UpdateProductStatusPath = '/admin/products/status';

  /**
   * Updates the status of product by admin.
   *
   * Updates the status of product based on the provided list of product ids and a status.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateProductStatus()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductStatus$Response(params: UpdateProductStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateProductStatus(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates the status of product by admin.
   *
   * Updates the status of product based on the provided list of product ids and a status.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateProductStatus$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateProductStatus(params: UpdateProductStatus$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateProductStatus$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getProducts()` */
  static readonly GetProductsPath = '/products';

  /**
   * Gets products.
   *
   * Returns a paged list of products visible to the authenticated merchant. Results are scoped to the caller's merchant context.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts$Response(params: GetProducts$Params, context?: HttpContext): Observable<StrictHttpResponse<PageProductPageResponse>> {
    const obs = getProducts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets products.
   *
   * Returns a paged list of products visible to the authenticated merchant. Results are scoped to the caller's merchant context.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts(params: GetProducts$Params, context?: HttpContext): Observable<PageProductPageResponse> {
    const resp = this.getProducts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PageProductPageResponse>): PageProductPageResponse => r.body)
    );
  }

  /** Path part for operation `createProduct()` */
  static readonly CreateProductPath = '/products';

  /**
   * Creates a new product.
   *
   * Creates a new product and returns the saved resource with its identifier.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProduct$Response(params: CreateProduct$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductCreateResponse>> {
    const obs = createProduct(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a new product.
   *
   * Creates a new product and returns the saved resource with its identifier.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createProduct(params: CreateProduct$Params, context?: HttpContext): Observable<ProductCreateResponse> {
    const resp = this.createProduct$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductCreateResponse>): ProductCreateResponse => r.body)
    );
  }

  /** Path part for operation `getCollectionPackagingUnitHierarchies()` */
  static readonly GetCollectionPackagingUnitHierarchiesPath = '/products/{packagingUnitId}/collections';

  /**
   * Gets all non unique collection packaging unit for the given packaging unit.
   *
   * Returns any number of list of non unique collection packaging unit. The number of lists equals the number of packaging units with the given packaging unit set as parent.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCollectionPackagingUnitHierarchies()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectionPackagingUnitHierarchies$Response(params: GetCollectionPackagingUnitHierarchies$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<Array<CollectionPackagingUnitHierarchyDto>>>> {
    const obs = getCollectionPackagingUnitHierarchies(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all non unique collection packaging unit for the given packaging unit.
   *
   * Returns any number of list of non unique collection packaging unit. The number of lists equals the number of packaging units with the given packaging unit set as parent.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCollectionPackagingUnitHierarchies$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCollectionPackagingUnitHierarchies(params: GetCollectionPackagingUnitHierarchies$Params, context?: HttpContext): Observable<Array<Array<CollectionPackagingUnitHierarchyDto>>> {
    const resp = this.getCollectionPackagingUnitHierarchies$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<Array<CollectionPackagingUnitHierarchyDto>>>): Array<Array<CollectionPackagingUnitHierarchyDto>> => r.body)
    );
  }

  /** Path part for operation `createCollectionPackagingUnit()` */
  static readonly CreateCollectionPackagingUnitPath = '/products/{packagingUnitId}/collections';

  /**
   * Creates a collection packaging unit as a child of the given product.
   *
   * Creates a new collection packaging unit as a child of the specified packagingUnitId. A collection allows grouping multiple packagingUnits into a hierarchy of up to 4 levels deep. Returns the saved resource with its collectionPackagingUnitId.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCollectionPackagingUnit()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCollectionPackagingUnit$Response(params: CreateCollectionPackagingUnit$Params, context?: HttpContext): Observable<StrictHttpResponse<CollectionPackagingUnitCreateResponse>> {
    const obs = createCollectionPackagingUnit(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Creates a collection packaging unit as a child of the given product.
   *
   * Creates a new collection packaging unit as a child of the specified packagingUnitId. A collection allows grouping multiple packagingUnits into a hierarchy of up to 4 levels deep. Returns the saved resource with its collectionPackagingUnitId.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCollectionPackagingUnit$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCollectionPackagingUnit(params: CreateCollectionPackagingUnit$Params, context?: HttpContext): Observable<CollectionPackagingUnitCreateResponse> {
    const resp = this.createCollectionPackagingUnit$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CollectionPackagingUnitCreateResponse>): CollectionPackagingUnitCreateResponse => r.body)
    );
  }

  /** Path part for operation `getIdsByEanCodes()` */
  static readonly GetIdsByEanCodesPath = '/products/ids-by-ean';

  /**
   * Gets packagingUnit IDs by EAN codes.
   *
   * For each EAN code in the request, returns the corresponding packagingUnitId. If no product is found for an EAN the value is null. Intended for TECHNICAL_USER (synchronization) to resolve EAN codes to packagingUnitIds.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getIdsByEanCodes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getIdsByEanCodes$Response(params: GetIdsByEanCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<PackagingUnitIdsByEanResponse>> {
    const obs = getIdsByEanCodes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets packagingUnit IDs by EAN codes.
   *
   * For each EAN code in the request, returns the corresponding packagingUnitId. If no product is found for an EAN the value is null. Intended for TECHNICAL_USER (synchronization) to resolve EAN codes to packagingUnitIds.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getIdsByEanCodes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getIdsByEanCodes(params: GetIdsByEanCodes$Params, context?: HttpContext): Observable<PackagingUnitIdsByEanResponse> {
    const resp = this.getIdsByEanCodes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PackagingUnitIdsByEanResponse>): PackagingUnitIdsByEanResponse => r.body)
    );
  }

  /** Path part for operation `getAllPackagingUnitIdEanPairs()` */
  static readonly GetAllPackagingUnitIdEanPairsPath = '/site/{siteId}/products/ids-by-ean';

  /**
   * Gets all EAN-to-packagingUnitId pairs for a site.
   *
   * Returns a map of EAN code → set of packagingUnitIds for all products in the sortiment of the given site. Use this endpoint to verify EAN-to-product mappings after synchronization. Requires TECHNICAL_USER role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllPackagingUnitIdEanPairs()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPackagingUnitIdEanPairs$Response(params: GetAllPackagingUnitIdEanPairs$Params, context?: HttpContext): Observable<StrictHttpResponse<{
[key: string]: Array<string>;
}>> {
    const obs = getAllPackagingUnitIdEanPairs(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets all EAN-to-packagingUnitId pairs for a site.
   *
   * Returns a map of EAN code → set of packagingUnitIds for all products in the sortiment of the given site. Use this endpoint to verify EAN-to-product mappings after synchronization. Requires TECHNICAL_USER role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllPackagingUnitIdEanPairs$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllPackagingUnitIdEanPairs(params: GetAllPackagingUnitIdEanPairs$Params, context?: HttpContext): Observable<{
[key: string]: Array<string>;
}> {
    const resp = this.getAllPackagingUnitIdEanPairs$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<{
[key: string]: Array<string>;
}>): {
[key: string]: Array<string>;
} => r.body)
    );
  }

  /** Path part for operation `getProductSheetById()` */
  static readonly GetProductSheetByIdPath = '/products/{packagingUnitId}/sheet';

  /**
   * Get the product sheet.
   *
   * Returns a summary view of the product including prices and supplier information. The 'marketplaceSection' parameter controls which side of the marketplace is shown: BUYING = prices from sellers visible to buyers; SELLING = prices from the caller's own selling context. Defaults to BUYING.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductSheetById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductSheetById$Response(params: GetProductSheetById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductSheetResponse>> {
    const obs = getProductSheetById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get the product sheet.
   *
   * Returns a summary view of the product including prices and supplier information. The 'marketplaceSection' parameter controls which side of the marketplace is shown: BUYING = prices from sellers visible to buyers; SELLING = prices from the caller's own selling context. Defaults to BUYING.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductSheetById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductSheetById(params: GetProductSheetById$Params, context?: HttpContext): Observable<ProductSheetResponse> {
    const resp = this.getProductSheetById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductSheetResponse>): ProductSheetResponse => r.body)
    );
  }

  /** Path part for operation `getProductsForAdminByMerchantNameAsHal()` */
  static readonly GetProductsForAdminByMerchantNameAsHalPath = '/merchants/{merchantId}/products';

  /**
   * Gets products of a specific merchant (admin).
   *
   * Returns a paged HAL list of products belonging to the specified merchant. Requires EASYLOT_ADMIN role. Filters are resolved from the merchant's company name.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductsForAdminByMerchantNameAsHal()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductsForAdminByMerchantNameAsHal$Response(params: GetProductsForAdminByMerchantNameAsHal$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductAdminResponse>> {
    const obs = getProductsForAdminByMerchantNameAsHal(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets products of a specific merchant (admin).
   *
   * Returns a paged HAL list of products belonging to the specified merchant. Requires EASYLOT_ADMIN role. Filters are resolved from the merchant's company name.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductsForAdminByMerchantNameAsHal$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductsForAdminByMerchantNameAsHal(params: GetProductsForAdminByMerchantNameAsHal$Params, context?: HttpContext): Observable<PagedModelProductAdminResponse> {
    const resp = this.getProductsForAdminByMerchantNameAsHal$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelProductAdminResponse>): PagedModelProductAdminResponse => r.body)
    );
  }

  /** Path part for operation `getProductsForAdmin()` */
  static readonly GetProductsForAdminPath = '/admin/products';

  /**
   * Gets products for admin (HAL).
   *
   * Returns a paged HAL representation of all products across all merchants. Requires EASYLOT_ADMIN role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductsForAdmin()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductsForAdmin$Response(params?: GetProductsForAdmin$Params, context?: HttpContext): Observable<StrictHttpResponse<PagedModelProductAdminResponse>> {
    const obs = getProductsForAdmin(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets products for admin (HAL).
   *
   * Returns a paged HAL representation of all products across all merchants. Requires EASYLOT_ADMIN role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductsForAdmin$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductsForAdmin(params?: GetProductsForAdmin$Params, context?: HttpContext): Observable<PagedModelProductAdminResponse> {
    const resp = this.getProductsForAdmin$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<PagedModelProductAdminResponse>): PagedModelProductAdminResponse => r.body)
    );
  }

  /** Path part for operation `getProductForAdminById()` */
  static readonly GetProductForAdminByIdPath = '/admin/products/{packagingUnitId}';

  /**
   * Gets product detail for admin.
   *
   * Returns full product details for the given packagingUnitId. Requires EASYLOT_ADMIN role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProductForAdminById()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductForAdminById$Response(params: GetProductForAdminById$Params, context?: HttpContext): Observable<StrictHttpResponse<ProductAdminResponse>> {
    const obs = getProductForAdminById(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets product detail for admin.
   *
   * Returns full product details for the given packagingUnitId. Requires EASYLOT_ADMIN role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getProductForAdminById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProductForAdminById(params: GetProductForAdminById$Params, context?: HttpContext): Observable<ProductAdminResponse> {
    const resp = this.getProductForAdminById$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ProductAdminResponse>): ProductAdminResponse => r.body)
    );
  }

}
